import React from "react";
import { Footer } from "../../common/Footer";
import { VisualisationCover } from "./VisualisationCover";
import { VisualisationProjects } from "./VisualisationProjects";

export const Visualisation = ({ setProject }) => {
  return (
    <div className="page">
      <VisualisationCover />
      <VisualisationProjects setProject={setProject} />
      <Footer />
    </div>
  );
};
